import React, { useEffect, useState, useRef, useLayoutEffect } from 'react';
import Footer from '../components/Footer';
import Main from '../components/Main';
import { useAuth } from '../context/AuthContext';
import CarouselGroup from '../components/CarouselGroup';
import Catalog from '../components/Catalog';
import { get_sliders, get_stone_gallery } from '../firebase-communication/firebase-database';
import SectionHeading from '../components/SectionHeading';
import { useTranslation } from 'react-i18next';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useLocation } from 'react-router-dom';

function MainPage() {
    const [t, i18n] = useTranslation("global");

    const { user } = useAuth();
    const isAdmin = !!user;

    const [sliderGroups, setSliderGroups] = useState([]);
    const [stoneGallery, setStoneGallery] = useState([]);

    const location = useLocation();
    const catalogRef = useRef(null);

    const fetchSliderGroups = async () => {
        const loadedSliderGroups = await get_sliders();
        setSliderGroups(loadedSliderGroups);
    };

    const fetchStoneGallery = async () => {
        const loadedStoneGallery = await get_stone_gallery();
        console.log('🔍 loaded stoneGallery:', loadedStoneGallery);
        setStoneGallery(loadedStoneGallery);
    };

    useEffect(() => {
        fetchSliderGroups();
        fetchStoneGallery();
    }, []);

    let samt = 0;

    useEffect(() => {
        AOS.init();
        window.addEventListener('load', AOS.refresh);
        window.addEventListener('scroll', function() {
            samt <= 10 ? samt++ : AOS.refresh();
        });
    }, []);

    useEffect(() => {
        AOS.refresh();
    }, [sliderGroups, stoneGallery]);    

    useLayoutEffect(() => {
        console.log(location);
        if (location.hash === "#catalog" && stoneGallery.length > 0 && catalogRef.current) {
          catalogRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
          AOS.refresh();
        }
      }, [location.hash, stoneGallery.length]);
    
    return (
        <div>
            <Main isAdmin={isAdmin} />

            {/* <SectionHeading>{t('sectionHeadings.products')}</SectionHeading> */}

            <CarouselGroup
                slidersGroups={sliderGroups}
                isAdmin={isAdmin}
                refreshSliderGroups={fetchSliderGroups}
            />

            {/* <SectionHeading>{t('sectionHeadings.stones')}</SectionHeading> */}

            {stoneGallery.length > 0 
            ?   <div  
                    id="catalog" 
                    ref={catalogRef} 
                    key={2221}
                    data-aos="fade-up"
                >
                <Catalog
                title={t('sectionHeadings.stones')}
                catalogData={stoneGallery}
                isAdmin={isAdmin}
                refreshCatalog={fetchStoneGallery}
                />
              </div>
            : <p>Loading stones…</p>
            }

            <Footer />
        </div>
    );
}

export default MainPage;
